"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SongwriterMyWritersHeader = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("p", null, "This page lists all your writer names and the songs associated with each, helping you easily view and manage your catalog")));
exports.default = SongwriterMyWritersHeader;
